import * as yup from 'yup';

const tokenTransferValidations = {
  phone: yup
    .string()
    .required('Phone number is required.')
    .matches(
      /^(\+1[2-9]\d{9}|1[2-9]\d{9}|\+91[6-9]\d{9}|91[6-9]\d{9}|[2-9]\d{9})$/,
      'Enter a valid US (+1XXXXXXXXXX) or Indian (+91XXXXXXXXXX) phone number.'
    ),
  tokens: yup
    .number()
    .typeError('Token Amount must be a number.')
    .required('Token Amount is required.')
    .integer('Tokens must be a whole number. No decimals allowed.')
    .min(1, 'Token Amount must be at least 1.')
    .max(10000, 'Token Amount cannot exceed 10,000.'),
};

export default tokenTransferValidations;
